import React from 'react';
import { reportError } from '../utils/errorReporter';

/**
 * Catches React render crashes anywhere below it, reports them to the backend,
 * and shows a friendly fallback instead of a blank white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportError({
      type: 'react',
      message: error && error.message ? error.message : String(error),
      stack: error && error.stack,
      componentStack: info && info.componentStack,
    });
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            padding: '40px',
            textAlign: 'center',
            fontFamily: 'system-ui, sans-serif',
          }}
        >
          <div style={{ fontSize: '48px' }}>⚠️</div>
          <h2 style={{ margin: 0, fontWeight: 800 }}>Something went wrong</h2>
          <p style={{ margin: 0, color: '#64748b', maxWidth: 420 }}>
            We hit an unexpected error. Our team has been notified. Please try again.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: 8,
              padding: '12px 28px',
              borderRadius: 12,
              border: 'none',
              background: '#2563eb',
              color: '#fff',
              fontWeight: 800,
              cursor: 'pointer',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
